import { APIEndpoints } from "../../constants";
import { APIGet, getAuthHeaders, APIResponse } from "../api/common.service";
import { User } from "../../types";

/**
 * Get user profile data endpoint.
 */
export function GetProfile(): Promise<APIResponse<User>> {
  return getAuthHeaders().then((headers) =>
    APIGet<User>(APIEndpoints.GetProfile, headers)
  );
}
